// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"b2fadc31","629":"89596edf","774":"b6d076e2","787":"28cb0dcd"}[chunkId] + ".chunk.js";
};